import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

const files = require.context("@/views", true, /\.vue$/);
const generator = []; // 一级路由
const gchildren = []; // 二级路由
files.keys().forEach(key => {
  const pages = files(key).default;
  if (pages.name) {
    const path = `/${pages.name.replace(/-/g, "/")}`;
    const nameSplit = pages.name.split("-");
    if (nameSplit.length > 1) {
      gchildren.push({
        path: path,
        name: pages.name,
        parent: nameSplit[0],
        component: () => import("@/" + key.replace("./", "views/")),
        // component: () => import(`@/views/${key.replace("./", "")}`),
        meta: getMeta(pages.meta, pages.name)
      });
    } else {
      generator.push({
        path: path,
        name: pages.name,
        component: () => import("@/" + key.replace("./", "views/")),
        // component: () => import(`@/views/${key.replace("./", "")}`),
        meta: getMeta(pages.meta, pages.name),
        children: []
      });
    }
  }
});

gchildren.forEach(item => {
  generator.map(pItem => {
    if (item.parent == pItem.name) {
      return pItem.children.push(item);
    }
  });
});

function getMeta(params = {}, name = "") {
  const keepAlive = params.keepAlive === undefined ? false : params.keepAlive;
  const tabNav = params.tabNav === undefined ? false : params.tabNav;
  const power = params.power === undefined ? true : params.power;
  const service = params.service === undefined ? true : params.service;
  if (keepAlive) {
    store.dispatch("PUSH_INCLUDE", name);
  }
  return {
    keepAlive,
    tabNav,
    power,
    service
  };
}

console.log("路由===", generator);
Vue.use(VueRouter);

const routes = [
  ...generator,
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "*",
    redirect: "/home"
  }
];

const router = new VueRouter({
  // mode: 'history', // 去掉#号
  // base: process.env.VUE_APP_BASE_URL
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err);
};

router.addRoutes(routes);
router.beforeEach((to, from, next) => {
  // 验证权限
  if (to.meta.power && !store.getters.token) {
    next("/logReg");
    return;
  }
  next();
});

router.afterEach((to, from) => {
  // 路由切换的时候，还有接口未完成，取消请求
  if (!from.name && from.path) {
    // 第一次进来的路由是'/',是没有带name
    return false;
  }
  if (store.getters.axiosPing.length) {
    for (const i in store.getters.axiosPing) {
      store.getters.axiosPing[i].f();
    }
  }
});

window.addEventListener("popstate", routeBack, false); // 监听路由返回
function routeBack() {
  store.dispatch("SET_BACK_FLAG", true);
  setTimeout(() => {
    store.dispatch("SET_BACK_FLAG", false);
  }, 20);
}

Vue.mixin({
  beforeRouteLeave(to, from, next) {
    if (this.$vnode && this.$vnode.data.keepAlive && store.getters.backFlag) {
      if (
        this.$vnode.parent &&
        this.$vnode.parent.componentInstance &&
        this.$vnode.parent.componentInstance.cache
      ) {
        if (this.$vnode.componentOptions) {
          var key =
            this.$vnode.key == null
              ? this.$vnode.componentOptions.Ctor.cid +
                (this.$vnode.componentOptions.tag
                  ? `::${this.$vnode.componentOptions.tag}`
                  : "")
              : this.$vnode.key;
          var cache = this.$vnode.parent.componentInstance.cache;
          var keys = this.$vnode.parent.componentInstance.keys;
          if (cache[key]) {
            if (keys.length) {
              var index = keys.indexOf(key);
              if (index > -1) {
                keys.splice(index, 1);
              }
            }
            delete cache[key];
          }
        }
      }
      from.meta.keepAlive = true;
    } else {
      window.scrollTo(0, 0);
    }
    next();
  }
});

export default router;
